import MothershipClient from '../mothershipClient';

export class AccountClient {
  registerUser(userData) {
    const url = '/app/account/register?source=WEBAPP';
    return MothershipClient.post(url, userData);
  }

  getEmailAvailability(email) {
    const url = '/app/account/email';
    return MothershipClient.get(url, { params: { email } });
  }

  sendResetPasswordEmail(email) {
    const url = '/app/account/reset?source=WEBAPP';
    const data = { email };
    return MothershipClient.post(url, data);
  }

  resetUserPassword(userData) {
    const url = '/app/account/reset/execute?source=WEBAPP';
    return MothershipClient.post(url, userData);
  }

  requestEmailVerification(userId) {
    const url = `/app/account/resend?userId=${userId}`;

    return MothershipClient.get(url);
  }
}

export default new AccountClient();
